import superagent from '@ott/superagent';

type BINInfo = {
  bin: string;
  paySystem: string;
  bank: string;
  type: string;
  class: string;
  bankCountry: string;
  bankCarePhone: string;
  countryCode: string;
  countryCodeAbbr: string;
  countryCodeNum: string;
  bankSite: string;
  bankPhone: string;
};

export const getCardInfoByBIN = async ({ bin }: { bin: string }) => {
  try {
    const {
      body: { error, result },
    } = await superagent.get(`/_pay/cardBins/${bin}`);

    if (error) {
      throw error;
    }

    return result as BINInfo;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};
